import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CountryState {
  prefix: string;
}

const initialState: CountryState = {
  prefix: 'in', // default
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountryPrefix(state, action: PayloadAction<string>) {
      state.prefix = action.payload;
    },
  },
});

export const { setCountryPrefix } = countrySlice.actions;
export default countrySlice.reducer; 